import React from "react";
import Icon from "../Icon";

const CircularProgress = ({ progress,showprogress=true, size = 40, strokeWidth = 4, color = "#ff3232", error }) => {
    const radius = (size - strokeWidth) / 2;
    const circumference = 2 * Math.PI * radius;
    const offset = circumference - (progress / 100) * circumference;

    return (
        <div style={{ position: "relative", width: size, height: size, }}>
            {/* Background circle */}
            {progress < 100 && !error ? <p
                style={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    fontSize: "12px",
                    fontWeight: "normal",
                    color: color
                }}
            >
                {showprogress ? progress + "%" : ""}
            </p> :
                <Icon alias={error ? "upload_failed" : "upload_completed"} width={24} color="none" style={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    fontSize: "12px",
                    fontWeight: "normal",
                }}
                    stroke={color}
                    strokeWidth={2} />
            }

            <svg width={size} height={size}>
                <circle
                    stroke="#FFF"
                    fill="transparent"
                    strokeWidth={strokeWidth}
                    r={radius}
                    cx={size / 2}
                    cy={size / 2}
                />

                {/* Progress circle */}
                <circle
                    stroke={color}
                    fill="transparent"
                    strokeWidth={strokeWidth}
                    r={radius}
                    cx={size / 2}
                    cy={size / 2}
                    strokeDasharray={circumference}
                    strokeDashoffset={offset}
                    strokeLinecap="round"
                    style={{ transition: "stroke-dashoffset 0.35s" }}
                />
            </svg>
            {/* Percentage text */}

        </div>
    );
};

export default CircularProgress;
